export function getStrapiURL(path = "") {
  return `${process.env.REACT_APP_STRAPI_API_URL}${path}`;
}
